import { useTranslation } from "react-i18next";
import PageHead from "../../components/PageHead";
import BillSelects from "./BillsSelects";
import { useState } from "react";
import { TFunction } from "i18next";
import { SortParams, TableColumn } from "../../components/Table";
import { getAxiosInstance } from "../../utils/axiosInstance";
import axios from "axios";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import SearchTable from "../../components/SearchTable";
import{ useEffect } from "react";
import BillViewModal from "./BillViewModal";
import { TransactionType } from "../../utils/types.global";
import EditBillModal from "./EditBillModal";
import Modal, { SimpleModalControls } from "../../components/Modal";
import { Button } from "@chakra-ui/react";
import PermissionGuard from "../../components/security/PermissionGuard";

type SearchOptions = {
    companyId?: string,
    placeOfBusinessId?: string,
    ProviderId?: string,
    startDate?: string,
    endDate?: string
}

interface SelectActionModal extends SimpleModalControls {
    edit: () => void;
    view: () => void;
}

const SelectActionModal = (props: SelectActionModal) => {
    const {
        isOpen,
        onClose,
        edit,
        view
    } = props;

    const { t } = useTranslation("translations");

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            header={t("SELECT_ACTION_MODAL_TITLE")}
        >
            <div className="w-full flex flex-col">
                <PermissionGuard permissions={["ViewBills"]}>
                    <Button
                        className="my-2"
                        onClick={() => view()}
                        colorScheme="green"
                    >
                        {t("VIEW_BILL_ACTION")}
                    </Button>
                </PermissionGuard>

                <PermissionGuard permissions={["EditBills"]}>
                    <Button
                        className="my-2"
                        onClick={() => edit()}
                        colorScheme="blue"
                    >
                        {t("EDIT_BILL_ACTION")}
                    </Button>
                </PermissionGuard>
            </div>
        </Modal>
    )
}

const getColumns = (t: TFunction<any>): TableColumn[] => [
    {
        Header: t("BILLNO"),
        accessor: "billNo",
        isSortable: true,
    },
    {
        Header: t("BILL_TYPE"),
        accessor: "billType",
        isSortable: false,
    },
    {
        Header: t("BILL_DATE"),
        accessor: "billDate",
        isSortable: true,
    },
    {
        Header: t("COMPANY_NAME"),
        accessor: "companyName",
    },
    {
        Header: t("PROVIDER_NAME"),
        accessor: "providerName",
    },
    {
        Header: t("PLACE_OF_BUSINESS"),
        accessor: "placeOffBusinessName",
    },
    {
        Header: t("CREATED_AT"),
        accessor: "createdAt",
        isSortable: true,
    }
];

type Bill = {
    id: string,
    billNo: string
    providerId: string,
    companyId: string,
    placeOfBusinessId: string,
    companyName: string,
    providerName: string,
    placeOffBusinessName: string,
    billAditionalDetails: any,
    transactions: [],
    billDate: string,
    createdAt: string,
    updatedAt: string
}

export type BillRendered = {
    id: string,
    billNo: string
    companyName: string,
    providerName: string,
    placeOffBusinessName: string,
    billAditionalDetails: any,
    transactions: [],
    billDate: string,
    createdAt: string,
    updatedAt: string
}

const Bills = () => {
    const [searchOptions, setSearchOptions] = useState<SearchOptions>();
    const [length, setLength] = useState<number>(0);
    const [fData, setFData] = useState<any[]>([]);
    const [viewData, setViewData] = useState<BillRendered>();

    const [actionModal, setActionModal] = useState<boolean>(false);
    const [viewModal, setViewModal] = useState<boolean>(false);
    const [editModal, setEditModal] = useState<boolean>(false);

    const [page, setPage] = useState<number>(1);
    const [perPage, setPerPage] = useState<number>(10);
    const [search, setSearch] = useState<string>("");
    const [sortParmas, setSortParams] = useState<SortParams | null>({  sortBy: "CreatedAt",isSortedDesc: true});

    const { t } = useTranslation("translations");

    const fetchData = async (
        currentPage: number = 1,
        perPage: number = 10,
        search: string | undefined,
        sortParams: SortParams | null,
        searchOptions: SearchOptions | undefined
    ) => {
        try {
            const res = await getAxiosInstance()?.get('/Bill', {
                params: {
                    CompanyId : searchOptions?.companyId,
                    PlaceOfBusinessId: searchOptions?.placeOfBusinessId,
                    ProviderId: searchOptions?.ProviderId,
                    startDate: searchOptions?.startDate ? new Date(searchOptions?.startDate).toUTCString() : undefined,
                    endDate: searchOptions?.endDate ? new Date(searchOptions?.endDate).toUTCString() : undefined,
                    PageNumber: currentPage,
                    PageSize: perPage,
                    SearchString: search,
                    SearchField: search ? "Name" : undefined,
                    SortBy: sortParams ? sortParams.sortBy : undefined,
                    SortDesc: sortParams ? sortParams.isSortedDesc : undefined
                }
            });
            const paginationData = JSON.parse(res?.headers.pagination);
            setLength(paginationData.totalItems);
            setFData(formData(res?.data, (paginationData.currentPage - 1) * paginationData.itemsPerPage));

        } catch (error) {
            if (axios.isAxiosError(error)) {
                toast.error(`${error.response?.data}`, { position: toast.POSITION.BOTTOM_RIGHT })
            } else {
                toast.error(`Could not retrieve the products from the database ${error}`, { position: toast.POSITION.BOTTOM_RIGHT });
            }
        }
    }


    const formData = (data: Bill[], length: number): BillRendered[] => {
        const lBill: BillRendered[] = [];
        let i = 0;
        for (const a of data) {
            let x = {
                id: a.id,
                no: i++,
                billNo: a.billNo,
                companyName: a.companyName,
                providerName: a.providerName,
                placeOffBusinessName: a.placeOffBusinessName,
                transactions: a.transactions,
                billAditionalDetails: a.billAditionalDetails,
                //@ts-ignore
                billType:  a.transactions.length > 0 ? t(TransactionType[a.transactions[0].type]) : "-",
                billDate: dayjs(a.billDate).format("DD-MM-YYYY"),
                createdAt: dayjs(a.createdAt).format("DD-MM-YYYY hh:mm"),
                updatedAt: dayjs(a.updatedAt).format("DD-MM-YYYY hh:mm"),
            }
            lBill.push(x);
        }
        return lBill;
    }
    
    useEffect(() => {
        fetchData(1,10,search,sortParmas,searchOptions);
    }, [searchOptions])

    return (
        <>
            <PageHead
                name={t("BILLS")}
            />

            <BillSelects
                searchAbleData={(data) => setSearchOptions(data)}
            />

            <SearchTable
                columns={getColumns(t)}
                data={fData}
                dataLength={length}
                onRowClick={(data) => {  setViewData(data); setActionModal(true); }}
                fetchData={(data) => fetchData(data.page, data.perPage, data.searchTerm, data.sortParams,searchOptions)}
                page={page}
                perPage={perPage}
                setPage={setPage}
                setPerPage={setPerPage}
                search={search}
                setSearch={setSearch}
                sortParams={sortParmas}
                setSortParams={setSortParams}
            />

            <BillViewModal 
                isOpen={viewModal}
                onClose={() => { setViewModal(false) }}
                data={viewData}
            />

            <EditBillModal
                isOpen={editModal && !!viewData}
                onClose={() => {
                    setEditModal(false);
                    fetchData(1, 10, search, sortParmas, searchOptions)
                }} 
                data={viewData}
            />

            <SelectActionModal
                isOpen={actionModal}
                onClose={() => setActionModal(false)}
                view={() => {
                    setActionModal(false)
                    setViewModal(true)
                }}
                edit={() => {
                    setActionModal(false)
                    setEditModal(true)
                }}
            />
        </>
    )
}

export default Bills;
